import React from 'react';
import UploadButton from './UploadButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';

// Single shared dashed-border dropzone used for both the empty and replace-file states.
const UploadDropZone = ({ accept, disabled, handleChange, promptText, className, leadingContent }) => {
    const uploadRef = React.useRef(null);
    const [dragActive, setDragActive] = React.useState(false);

    const handleDragEvent = event => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleDragEnter = event => {
        handleDragEvent(event);
        if (!disabled) {
            setDragActive(true);
        }
    };

    const handleDragOver = event => {
        handleDragEvent(event);
        if (!disabled) {
            event.dataTransfer.dropEffect = 'copy';
            setDragActive(true);
        }
    };

    const handleDragLeave = event => {
        handleDragEvent(event);
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setDragActive(false);
        }
    };

    const handleDrop = event => {
        handleDragEvent(event);
        setDragActive(false);
        if (disabled) {
            return;
        }

        const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (file) {
            handleChange(file);
        }
    };

    const handleBrowseClick = event => {
        event.preventDefault();
        event.stopPropagation();
        if (disabled) {
            return;
        }
        if (uploadRef.current && uploadRef.current.trigger) {
            uploadRef.current.trigger();
        }
    };

    return (
        <div
            className={`doc-card__actions${dragActive ? ' doc-card__actions--drag-active' : ''}`}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            data-upload-drop-area="true"
        >
            {leadingContent}
            <UploadButton
                ref={uploadRef}
                accept={accept}
                disabled={disabled}
                size="sm"
                isDropZone
                enableDrop={false}
                dragActive={dragActive}
                dragText={<span className="doc-card__drop-zone-content"><FontAwesomeIcon className="doc-card__btn-icon" icon={faUpload} />Drop to upload</span>}
                className={className || 'doc-card__drop-zone'}
                handleChange={handleChange}
            >
                <span className="doc-card__drop-zone-content">
                    <FontAwesomeIcon className="doc-card__btn-icon" icon={faUpload} />
                    <span className="doc-card__drop-zone-text">{promptText} or <a href="#" className="doc-card__drop-zone-link" onClick={handleBrowseClick}>browse</a></span>
                </span>
            </UploadButton>
        </div>
    );
};

export default UploadDropZone;
